module.exports = __webpack_public_path__ + "img/1440.33104650.svg";